/*
 * @Author: your name
 * @Date: 2021-09-13 20:16:04
 * @LastEditTime: 2021-10-14 12:08:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Bounty\src\main.js
 */

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入样式
import 'swiper/dist/css/swiper.css'

// 多国语
import i18n from './i18n'

// 核心插件
import bounty from '@/plugin/bounty'

// 核心插件
Vue.use(bounty)

function resizeCount () {
  const baseConstn = 75 // 1920的设计稿 / 基数10
  const nowWidth = document.documentElement.clientWidth
  const nowCount = nowWidth / baseConstn
  document.querySelector('html').style.fontSize = nowCount + 'px'
}
// 初始化
resizeCount()

window.addEventListener('resize', () => {
  resizeCount()
})

export default new Vue({
  data: {
    contract: ''
  },
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
